var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M6.23894 2.60507H18.4609V4.45407H6.23894V2.60507ZM1.53894 2.14307H4.35894V4.91607H1.53894V2.14307ZM1.53894 8.61307H4.35894V11.3861H1.53894V8.61307ZM1.53894 15.0831H4.35894V17.8561H1.53894V15.0831ZM6.23894 9.07507H18.4609V10.9241H6.23894V9.07507ZM6.23894 15.5451H18.4609V17.3941H6.23894V15.5451Z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }